import StringKey from "./StringKey";
import StringLocale from "./StringLocale";

export const components = {
    StringKey,
    StringLocale,
};
